import * as BaseApi from "api/Base.api";
import { IUserStudent } from "api/interfaces/user.interface";
import { IPagination } from "api/interfaces/common.interface";

const BASE_URL = "/agency/v2/rank";


export interface IRankHomeInfo {
    castingMangerViewCountRankList: IUserStudent[],
    favoriteCountRankList: IUserStudent[],
}

//* 지망생 뷰카운트 랭킹 조회
//  2025-01-XX 추가
//  희문
//* Params
//  page : 페이지 번호
//  limit : 페이지 당 데이터 개수
export const getRankHomeInfo = async () => {
    return await BaseApi.get(`${BASE_URL}`);
};